// MODEL : instance of Domain
//
//every time user clicks on domain
// a new instance of this is created and initialized.
define('app/dashboard/panels/FundingDashboardPanel',['require','./DashboardPanel','glu/util','hbs!./FundingDashboardPanel.hbs'],function(require) {

	'use strict';
	var DashboardPanel = require('./DashboardPanel'),
		_ = require('glu/util');

	return DashboardPanel.extend({
		template: require('hbs!./FundingDashboardPanel.hbs'),

		ui: function() {
			return _.extend(DashboardPanel.prototype.ui, {
				$topContainer: '.top-container',
				$bottomLeftContainer: '.bottom-left-container',
				$bottomRightContainer: '.bottom-right-container'
			});
		},

		/**
		 * My reports and others tabs do not exist with this dashboard panel.
		 */
		addViews: function() {

		},

		/**
		 * Disable drag and drop for this dashboard panel.
		 */
		enableDragAndDrop: function() {

		},

		/**
		 * Determine the best location for the widget.  For now we have to use the widget name to determine
		 * the best location.  In the future we may want to add something to the report model to make this less fragile.
		 */
		addWidget: function(view, model, selector) {
			var tab = this.$('#dashboard-tab-my-widgets'),
				uiContainer = model.get('options').uiContainer;

			var $renderedEl = view.render().$el;

			$renderedEl.attr('data-qa', model.get('name'));

			switch (uiContainer) {
				case 'top-left-container':
					tab.find('.top-left-container .kpi-style-1').append($renderedEl);
					break;
				case 'top-right-container':
					tab.find('.top-right-container .kpi-style-1').append($renderedEl);
					break;
				case 'bottom-left-container':
					tab.find('.bottom-left-container .kpi-style-1').append($renderedEl);
					break;
				default:
					tab.find(selector).append($renderedEl);
			}

			this.widgets.push(view);
		}
	});
});

